import { setNotificationAdapter } from "@spark/services/http";
import { notification } from '@spark/ui-components/utils/notification';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './containers/App/App';
import './i18n';
setNotificationAdapter(notification);
window.addEventListener('unhandledrejection', (event) => {
  const status = event?.reason?.response?.status;
  if (status === 401) {
    event.preventDefault();
  }
});
const root = createRoot(document.getElementById('root'));

root.render(<React.StrictMode>
    <App />
  </React.StrictMode>); // If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

// O boilerplate serviceWorker.unregister() do CRA foi removido: ele desregistrava
// o push-sw.js (Web Push) a cada carregamento da página.
